import { call, put, takeLatest } from "redux-saga/effects";
import { selectPassengerRequest, selectPassengerSuccess, selectPassengerFailure, passengerDataRequest, passengerDataSuccess, passengerDataFailure } from "../../slice/checkin/selectPassengerDetailsSlice";
import api from "../../../../config/api";
import { config } from "../../../../config/global";
import i18n from "../../../../i18n";
const fetchSelectPassengerData = async selectPassengers => {
  const SELECTION_PASSENGER_API_URL = config.SELECT_PASSENGER_REGULATORY_CHECKIN;
  const data = {
    mode: "no-cors",
    headers: {
      "App-Authorization": localStorage.getItem("accesstoken") || "",
      "Accept-Language": `${i18n.language}`,
      "Content-Type": "application/json"
    },
    loader: true,
    isGenericErr: true,
    isBadRequestExceptional: false
  };
  const response = await api.post(`${SELECTION_PASSENGER_API_URL}`, selectPassengers, data);
  return response;
};
const fetchPassengerData = async payload => {
  const PASSENGER_DATA_API_URL = config.SELECT_PASSENGER_DATA_CHECKIN;
  const data = {
    mode: "no-cors",
    headers: {
      AccessToken: sessionStorage.getItem("checkintoken"),
      "Content-Type": "application/json"
    },
    loader: true,
    isGenericErr: true,
    isBadRequestExceptional: false
  };
  const response = await api.post(PASSENGER_DATA_API_URL, payload, data);
  return response;
};
function* getSelectPassengerData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchSelectPassengerData, payload);
    yield put(selectPassengerSuccess(response.data));
  } catch (error) {
    yield put(selectPassengerFailure(error));
  }
}
function* getPassengerData(action) {
  try {
    const response = yield call(fetchPassengerData, action.payload);
    const data = response?.data;
    yield put(passengerDataSuccess(data));
  } catch (error) {
    yield put(passengerDataFailure(error));
  }
}
export function* watchSelectPassengerData() {
  yield takeLatest(selectPassengerRequest.type, getSelectPassengerData);
}
export function* watchPassengerData() {
  yield takeLatest(passengerDataRequest.type, getPassengerData);
}